// Turn a 2-letter region/ISO code into its flag emoji using Unicode
// regional-indicator symbols ('in' -> 🇮🇳). Falls back to a globe.
export function codeToFlag(code?: string | null): string {
  if (!code || code.length !== 2) return "🌐";
  const cc = code.toLowerCase();
  const a = cc.charCodeAt(0);
  const b = cc.charCodeAt(1);
  if (a < 97 || a > 122 || b < 97 || b > 122) return "🌐";
  const BASE = 0x1f1e6; // regional indicator 'a'
  return String.fromCodePoint(BASE + (a - 97), BASE + (b - 97));
}
